import clsx from "clsx";
import { QueryBuilderContext } from "contexts/QueryBuilderContextProvider";
import React, { useContext, useMemo } from "react";
import FilterSelect from "./FilterSelect/FilterSelect";

// All supported periods to request prediction
export const predictionOptions = [
  {
    id: 1,
    friendlyName: "Next 7 Days",
    name: "next7Days",
    value: 7,
  },
  {
    id: 2,
    friendlyName: "Next 14 Days",
    name: "next14Days",
    value: 14,
  },
  {
    id: 3,
    friendlyName: "Next 30 Days",
    name: "next30Days",
    value: 30,
  },
];

/**
 * Element to display the info about the current prediction, allowing to determine the period range
 * @param {*} props
 * @returns
 */
const QueryPredictionOptions = (props) => {
  const { state, dispatch } = useContext(QueryBuilderContext);
  const { loadPredictions, predictionRange } = state;

  /**
   * Disables the prediction and remove its element from the query
   */
  const renderRemovePredictionButton = useMemo(
    () => (
      <div className="query-remove-container">
        <button
          className="filter-remove-element-btn"
          onClick={(e) => {
            dispatch({ type: "SET-LOAD-PREDICTIONS", payload: false });
          }}
        />
      </div>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loadPredictions]
  );

  /**
   * Persist the current prediction range in the query
   * @param {*} range
   * @returns
   */
  const setPredictionRange = (range) =>
    dispatch({ type: "SET-PREDICTIONS-RANGE", payload: range });

  return (
    <>
      {loadPredictions && (
        <>
          <div className="query-element">
            <span className="ml-1">
              <span>{props.filters.length > 0 ? "and" : ""} </span>
              <span className="text-info">Predict </span>
              <span>the </span>
            </span>
          </div>
          <div className="query-element">
            <FilterSelect
              mode="simple"
              data={predictionOptions}
              value={predictionRange}
              alwaysOpen={false}
              onChangeParent={(idx, value) => setPredictionRange(value)}
            />
            <div className={clsx("filter-remove-button-container")}>
              {renderRemovePredictionButton}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default QueryPredictionOptions;
